import styles from "./DispatchDetails.module.scss";
const DispatchDetails = () => {
  return (
    <div className={styles.container}>
      Dispatch Details Not Available in WebTool v1
    </div>
  );
};
export default DispatchDetails;
